import React, { useState } from 'react';
import {
  Accordion,
  Col,
  FilterAccordionHeader,
  Row,
  Select,
  TextField,
  TextArea
} from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field, useForm } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import {
  reportStatusOptions,
  reportVisibilityOptions
} from '../../../../../constants/dataOptions';
import { required } from '../../../../../helpers/Validations';
import useReportTypesAPI from '../../../../../hooks/useReportTypesAPI';
import { reportTypesToOptions } from '../../../../../helpers/reportTypeUtils';
import LocalizedTextField from '../../../../common/LocalizedTextField';

function AdministrativeData() {
  const [filterToggle, setFilterToggle] = useState(true);
  const intl = useIntl();
  const form = useForm();
  const { reportTypes, isLoading } = useReportTypesAPI();
  const reportTypeOptions = reportTypesToOptions(reportTypes, intl);

  return (
    <>
      <Accordion
        id="save-new-report-administrativeData-accordion"
        label={
          <FormattedMessage
            id="ui-reports.saveNewReportForm.administrativeData.accordion.header"
            defaultMessage="Administrative data"
          />
        }
        onToggle={() => setFilterToggle(!filterToggle)}
        open={filterToggle}
        separator={false}
        header={FilterAccordionHeader}
      >
        <Row>
          <Col xs={12}>
            <FieldArray
              name="reportName"
              component={LocalizedTextField}
              fieldComponent={TextField}
              fieldLabel={
                <FormattedMessage
                  id="ui-reports.saveNewReportForm.reportNameField.label"
                  defaultMessage="Report name"
                />
              }
              isRequired
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FieldArray
              name="reportDesc"
              component={LocalizedTextField}
              fieldComponent={TextArea}
              fieldLabel={
                <FormattedMessage
                  id="ui-reports.saveNewReportForm.reportDescField.label"
                  defaultMessage="Report description"
                />
              }
              isRequired
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              id="save-new-form-report-type-select"
              name="reportType"
              component={Select}
              label={
                <FormattedMessage
                  id="ui-reports.saveNewReportForm.reportTypeField.label"
                  defaultMessage="Report type"
                />
              }
              placeholder={intl.formatMessage({
                id: 'ui-reports.saveNewReportForm.reportTypeField.placeholder',
                defaultMessage: 'Select report type'
              })}
              dataOptions={reportTypeOptions}
              required
              validate={required}
            >
              {({ input }) => (
                <Select
                  {...input}
                  id="save-new-form-report-type-select"
                  label={
                    <FormattedMessage
                      id="ui-reports.saveNewReportForm.reportTypeField.label"
                      defaultMessage="Report type"
                    />
                  }
                  placeholder={intl.formatMessage({
                    id: 'ui-reports.saveNewReportForm.reportTypeField.placeholder',
                    defaultMessage: 'Select report type'
                  })}
                  dataOptions={reportTypeOptions}
                  onChange={(e) => {
                    input.onChange(e);
                  }}
                  required
                />
              )}
            </Field>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Field
              id="save-new-form-report-desc-selectField"
              name="reportStatus"
              component={Select}
              label={
                <FormattedMessage
                  id="ui-reports.saveNewReportForm.reportStatusField.label"
                  defaultMessage="Report status"
                />
              }
              placeholder={intl.formatMessage({
                id: 'ui-reports.saveNewReportForm.reportStatusField.placeholder',
                defaultMessage: 'Enter report status'
              })}
              dataOptions={reportStatusOptions(intl)}
              required
            />
          </Col>
          <Col xs={6}>
            <Field
              id="save-new-form-report-visibility-select-Field"
              name="visibility"
              component={Select}
              label={
                <FormattedMessage
                  id="ui-reports.saveNewReportForm.reportVisibilityField.label"
                  defaultMessage="Visibility"
                />
              }
              placeholder={intl.formatMessage({
                id: 'ui-reports.saveNewReportForm.reportVisibilityField.placeholder',
                defaultMessage: 'Select visibility'
              })}
              dataOptions={reportVisibilityOptions(intl)}
              required
            />
          </Col>
        </Row>
      </Accordion>
    </>
  );
}

AdministrativeData.propTypes = {};

export default AdministrativeData;
